<ng-container *ngTemplateOutlet="includeModal ? modal : changePasswordFormTemplate"></ng-container>
<ng-template #modal>
  <div class="modal-header">
    <h2 class="modal-title">Security settings</h2>
    <i class="fa fa-2x fa-times" (click)="cancel()"></i>
  </div>

  <div class="modal-body">
    <div class="mb-4 card p-4">
      <baxter-library-mfa-settings-cognito></baxter-library-mfa-settings-cognito>
    </div>
    <div class="card ps-4 pe-4">
      <div class="changePasswordWidget pb-4">
        <h5 class="mt-4">Change password</h5>
        <ng-container *ngTemplateOutlet="changePasswordFormTemplate"></ng-container>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col">
        <div class="row d-flex justify-content-around">
          <div class="col">
            <button class="btn btn-outline-primary" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mfaFormTemplate>
  <div class="row" *ngIf="user && !setAuthenticatorApp">
    <h5>Multi factor authentication</h5>
    <div class="col">
      User MFA: {{user.preferredMFA === 'NOMFA' ? 'Inactive' : 'Active'}}
    </div>
<!--    <div class="col" *ngIf="user && user.preferredMFA !== 'NOMFA' && !setAuthenticatorApp">-->
<!--      <button class="btn btn-primary btn-sm" (click)="enableSetAuthenticatorApp()">Replace software token</button>-->
<!--    </div>-->
  </div>
  <div class="row">
    <div class="col" *ngIf="user && user.preferredMFA === 'NOMFA' && !setAuthenticatorApp">
      <button class="btn btn-primary" (click)="enableSetAuthenticatorApp()">Setup authenticator app</button>
    </div>
  </div>
  <div class="row mt-3" *ngIf="user && user.preferredMFA !== 'NOMFA' && !setAuthenticatorApp">
    <div class="col">
      <button class="btn btn-primary btn-sm" (click)="enableSetAuthenticatorApp()">Replace software token</button>
    </div>
  </div>
  <div class="row" *ngIf="setAuthenticatorApp">
    <div class="col">
      <div class="row">
        <div class="col">
          <h5>Use Authenticator Application</h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          Scan the QR code with your authenticator app to receive verification codes. You can also manually enter the below code in your authenticator app.
        </div>
      </div>
      <div class="row d-flex justify-content-center mt-3">
        <div class="card" style="width: 270px">
          <qrcode [qrdata]="qrCode" [width]="256"></qrcode>
        </div>
        <div class="card d-flex justify-content-center align-items-center ms-2" style="width: calc(100% - 300px); min-width: 300px; height: 264px;">
          <div class="text-center ps-5 pe-5">
            <div class="manual-entry-label">MANUAL ENTRY</div>
            <div style="word-break: break-all;">{{associateResp?.secretCode}}</div>
          </div>
        </div>
      </div>
<!--      <div class="row d-flex justify-content-center mt-3">-->
<!--        <div class="card" style="width: fit-content">-->
<!--          <qrcode [qrdata]="qrCode" [width]="256"></qrcode>-->
<!--        </div>-->
<!--        <div class="card d-flex justify-content-center align-items-center ms-3" style="width: fit-content; height: 264px;">-->
<!--          <div class="text-center ps-5 pe-5">-->
<!--            <div>MANUAL ENTRY</div>-->
<!--            <div style="word-break: break-all;">{{associateResp?.secretCode}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row">-->
<!--        <div class="col">-->
<!--          <button class="btn btn-primary" (click)="nextToEnterTOTP()">Next</button>-->
<!--        </div>-->
<!--      </div>-->
      <div class="row" [formGroup]="mfaFormGroup">
        <div class="col ms-lg-1 ms-md-5 ps-0">
          <input type="text" class="form-control" style="width: 268px;" formControlName="code" data-lpignore="true" [placeholder]="'Enter TOTP Code'">
        </div>
        <div class="col">
          <button class="btn btn-primary" (click)="verifySoftwareToken()">Submit</button>
        </div>
      </div>
    </div>
  </div>
<!--  <div class="row" *ngIf="enterTOTP" [formGroup]="mfaFormGroup" style="height: 280px">-->
<!--    <div class="col">-->
<!--      <input type="text" class="form-control" formControlName="code" data-lpignore="true" [placeholder]="'TOTP Code'">-->
<!--    </div>-->
<!--    <div class="col">-->
<!--      <button class="btn btn-primary" (click)="verifySoftwareToken()">Submit</button>-->
<!--    </div>-->
<!--  </div>-->


</ng-template>
<ng-template #changePasswordFormTemplate>
  <form [formGroup]="form" class="settings-form">

    <div class="form-floating mb-3">
      <input type="password"
             formControlName="oldPassword"
             id="oldPasswordInput"
             autocomplete="off"
             class="form-control form-control-sm"
             data-lpignore="true"
             placeholder="Old password">
      <label for="oldPasswordInput">Old password</label>
    </div>
    <div class="form-floating mb-3">
      <input type="password"
             formControlName="newPassword"
             id="newPasswordInput"
             autocomplete="off"
             class="form-control form-control-sm"
             data-lpignore="true"
             placeholder="Old password">
      <label for="newPasswordInput">New password</label>
      <ng-container
        *ngIf="submitted && form.controls['newPassword'].errors"
        [ngTemplateOutlet]="passwordErrorsTemplate"
        [ngTemplateOutletContext]="{form: form, formField: 'newPassword'}">
      </ng-container>
    </div>
    <div class="form-floating mb-3">
      <input type="password"
             formControlName="newPasswordconf"
             id="newPasswordConfInput"
             autocomplete="off"
             class="form-control form-control-sm"
             data-lpignore="true"
             placeholder="Old password">
      <label for="newPasswordConfInput">Confirm new password</label>
    </div>
    <p class="passwords-not-match-paragraph" *ngIf="submitted && (form.errors && form.errors['passwordsMatched'])">
      The passwords do not match
    </p>
  </form>

  <div class="col">
    <button class="btn btn-secondary" (click)="submit()" [disabled]="form.invalid && submitted">Submit</button>
  </div>

</ng-template>

<ng-template #passwordErrorsTemplate let-form="form" let-formField="formField">
  <div class="invalid-feedback" style="display: block">
    <div *ngIf="form.controls[formField].errors['minlength'] || form.controls[formField].errors['required']">Password must contain at least {{authenticatorConfig.passwordPolicy.MinimumLength}} characters</div>
    <div *ngIf="form.controls[formField].errors['pattern']">Password must contains an upper case letter, a lower case letter, a number, and a special character</div>
    <div *ngIf="form.controls[formField].errors['lowerCase']">Password must contain a lower case letter</div>
    <div *ngIf="form.controls[formField].errors['upperCase']">Password must contain an upper case letter</div>
    <div *ngIf="form.controls[formField].errors['number']">Password must contain a number</div>
    <div *ngIf="form.controls[formField].errors['specialCharacter']">Password must contain a special character</div>
    <div *ngIf="form.controls[formField].errors['maxLength']">Password too long</div>
  </div>
</ng-template>
